export default class List {
    constructor() {
        this.isSp = true;

        this.init();
    }

    init() {
        this._setBp();
    }

    _setBp() {
        const mediaQuery = window.matchMedia("(max-width: 1019px)");
        // イベントリスナーを登録

        mediaQuery.addListener((e) => {
            this._handleTabletChange(e);
        });

        this._handleTabletChange(mediaQuery);
    }

    _handleTabletChange(e) {
        if (e.matches) {
            this.isSp = true;
            
        } else {
            this.isSp = false;
            this.setListItem();
        }
    }

    setListItem() {
        const list = document.querySelector(".special__list");
        const item = [...document.querySelectorAll(".special__item")];

        const itemlength = item.length;

        const itemspacer = `<li class="special__item -spacer -item"><span></span></li>`;

        if (itemlength === 1) {
            list.insertAdjacentHTML("beforeend", itemspacer);
            list.insertAdjacentHTML("beforeend", itemspacer);
        } else if (itemlength === 2) {
            list.insertAdjacentHTML("beforeend", itemspacer);
        }
    }

}
